module.exports = "<span ng-message=pattern>*Must be a valid email address</span> ";